<div class="status-select-container">
  <div class="status-badge"
       (click)="toggleDropdown($event)"
       [ngClass]="{'loading': isLoading, 'disabled': disabled, 'locked': isLocked}"
       [matTooltip]="isLocked ? (lockedMessageKey | translate) : ''"
       matTooltipPosition="above"
       [ngStyle]="{
         'background-color': getChipBackgroundColor(permit?.state?.color),
         'color': '#000000'
       }">
    <span class="status-indicator" [ngStyle]="{'background-color': permit?.state?.color}"></span>
    <span class="status-text">{{ statusName(permit?.state?.name) }}</span>
    <mat-icon class="locked-icon" *ngIf="isLocked">lock</mat-icon>
    <span class="loading-spinner" *ngIf="isLoading"></span>
  </div>

  <div class="status-dropdown"
       *ngIf="isOpen"
       [style.position]="'fixed'"
       [style.top.px]="dropdownPosition?.top"
       [style.left.px]="dropdownPosition?.left">
    <div class="dropdown-title">{{ 'permit.manage.status_dialog.title' | translate }}</div>

    <!-- List mode: the allowed transitions are per-permit and absent from the list payload -->
    <div class="dropdown-loading" *ngIf="transitionsLoading">
      {{ 'permit.manage.status_select.loading' | translate }}
    </div>

    <!-- Nothing to offer: an expected state, so explain it instead of showing an empty menu -->
    <div class="dropdown-locked" *ngIf="!transitionsLoading && isLocked">
      <mat-icon class="dropdown-locked-icon">lock</mat-icon>
      <span>{{ lockedMessageKey | translate }}</span>
    </div>

    <div class="status-menu" *ngIf="!transitionsLoading && transitions?.length">
      <div class="status-option"
           *ngFor="let status of transitions"
           (click)="onStatusSelected(status)"
           [class.active]="status._id === permit?.state?._id">
        <div class="status-option-badge"
             [ngStyle]="{
               'background-color': getChipBackgroundColor(status.color),
               'color': '#000000'
             }">
          <span class="status-option-indicator" [ngStyle]="{'background-color': status.color}"></span>
          {{ statusName(status.name) }}
        </div>
      </div>
    </div>

    <!-- Same status, different options depending on how the permit got here: name it, or it reads as a bug -->
    <div class="dropdown-hint" *ngIf="showPendingInfoHint">
      {{ 'permit.manage.status_select.pending_info_hint' | translate }}
    </div>
  </div>
</div>
